/**
 * O que mudou no app, escrito para quem usa o app.
 *
 * Curado à mão, e não gerado do histórico de commits, por um motivo só: o
 * commit é escrito para quem programa. "fix(web): tira a folha inferior de trás
 * da barra de abas no iOS" é uma frase correta e inútil para o barbeiro — o que
 * ele precisa ler é que o botão de marcar parou de sumir no iPhone dele.
 *
 * A lista mora aqui, junto do resto do texto visível, e não num CHANGELOG.md na
 * raiz: um segundo lugar de texto de interface é um lugar que sai de sincronia.
 *
 * Regras para escrever uma entrada nova:
 *
 * - **Mais recente primeiro.** A tela mostra nesta ordem, sem reordenar.
 * - **Uma entrada por dia de publicação**, não por commit. Quem lê quer saber o
 *   que mudou, não quantas vezes o deploy rodou.
 * - **Só o que dá para perceber usando.** Refatoração, migração de banco e
 *   ajuste de infraestrutura não entram — se ninguém consegue notar, escrever
 *   sobre isso só enche a tela e faz a próxima novidade de verdade passar batido.
 * - **A data é de calendário**, no fuso de quem publicou, e não vira instante em
 *   lugar nenhum: ela é um rótulo, não um horário.
 */

export interface ReleaseNote {
  /** `AAAA-MM-DD` — data de calendário, formatada sem conversão de fuso. */
  date: string;
  items: string[];
}

export const RELEASE_NOTES: ReleaseNote[] = [
  {
    date: '2026-10-11',
    items: [
      'Horário fixo: o cliente que vem toda terça, ou quarta sim, quarta não, fica marcado sozinho com semanas de antecedência. Monte pela ficha dele ou pelo “Repetir” do atendimento.',
      'Quando uma data do horário fixo cai em feriado ou em cima de outro cliente, ela aparece em Pedidos para você decidir.',
    ],
  },
  {
    date: '2026-08-13',
    items: [
      'Ajustes ganhou a seção “Sobre”, com as novidades e a versão que está neste aparelho.',
      'No iPhone, o botão de marcar parou de ficar escondido atrás da barra de abas.',
    ],
  },
  {
    date: '2026-08-12',
    items: [
      'A agenda abre no horário de agora, em vez de começar o dia às 8h.',
      'O nome do atalho na tela de início é escolhido pela barbearia.',
    ],
  },
  {
    date: '2026-08-11',
    items: [
      'Dá para entrar com Face ID, Touch ID ou digital, sem digitar senha.',
      'O convite para instalar o app na tela de início.',
      'O cliente edita os próprios dados — nome, telefone, foto e aniversário.',
    ],
  },
];
